import { render } from "./EditorBox.vue?vue&type=template&id=2f1c0d0b&scoped=true"
import script from "./EditorBox.vue?vue&type=script&lang=js"
export * from "./EditorBox.vue?vue&type=script&lang=js"

import "./EditorBox.vue?vue&type=style&index=0&id=2f1c0d0b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2f1c0d0b"

export default script